import { render, staticRenderFns } from "./PopUpUnlinkFb.vue?vue&type=template&id=23a500e1"
import script from "./PopUpUnlinkFb.vue?vue&type=script&lang=js"
export * from "./PopUpUnlinkFb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports